import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import IconFilterBold from 'design-system/icons/IconFilterBold';
import IconArrowCollapsed from 'design-system/icons/IconArrowCollapsed';
import useColors from 'hooks/useColors';
import { interpolateColor, useAnimatedStyle } from 'react-native-reanimated';
import { AnimatedTouchableBounce } from 'design-system/AnimatedComponents';
import { isWeb } from '../../../../constants';
const BroadBandQuotesHeader = ({ label, scrollY, onPress, onPressFilters }) => {
    const colors = useColors();
    const bgStyles = useAnimatedStyle(() => ({
        backgroundColor: interpolateColor(scrollY.value, [0, 40], [
            colors.cards.onDark,
            colors.background.dark,
        ]),
    }));
    return (<View style={styles.content}>
      <AnimatedTouchableBounce onPress={onPressFilters} style={[styles.button, bgStyles]}>
        <IconFilterBold color={colors.text.secondary}/>
        <Spacer.W8 />
        <Text Text-14 Secondary>
          Filter
        </Text>
      </AnimatedTouchableBounce>
      <AnimatedTouchableBounce onPress={onPress} style={[styles.button, styles.paddingHorizontal12, bgStyles]}>
        <Text Text-14 Secondary>
          {label}
        </Text>
        <Spacer w={4}/>
        <IconArrowCollapsed color={colors.text.secondary}/>
      </AnimatedTouchableBounce>
    </View>);
};
const styles = StyleSheet.create({
    content: {
        paddingHorizontal: rem(16),
        paddingTop: rem(8),
        paddingBottom: rem(4),
        flexDirection: 'row',
        justifyContent: 'space-between',
        ...(isWeb && {
            gap: rem(8),
        }),
    },
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        height: rem(34),
        paddingHorizontal: rem(8),
        borderRadius: rem(8),
    },
    paddingHorizontal12: {
        paddingHorizontal: rem(12),
    },
});
export default memo(BroadBandQuotesHeader);
